import { render } from "./HomePageView.vue?vue&type=template&id=044aec34"
import script from "./HomePageView.vue?vue&type=script&lang=js"
export * from "./HomePageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__